<template>
    <div class="contact">
        <TheHeader :headerIsFixed="true" />
        <div class="bg-img-right-shop bg-center bg-cover pb-8 block clear pt-32 sm:pt-48 md:pt-64">
            <div class="text-center mx-6 sm:mx-auto sm:w-128 p-3 bg-black-transparent rounded-lg">
                <h1 class="text-white text-lg sm:text-2xl font-normal mb-2"
                    :class="{ 'search-extra-margin': searchIsFixed }">Find a Certified Auto Repair Center</h1>
                <TheShopsSearch />
                <div v-show="searchIsFixed" class="h-10 w-64 sm:w-96 md:w-120"></div>
                <p class="text-white mt-2">Search Thousands of Locations</p>
            </div>
        </div>
        <div class="sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl mx-3 sm:mx-auto p-3 sm:mt-4">
            <section>
                <h2 class="text-xl sm:text-xl">The Importance of ASE Certified Repair</h2>
                <p class="mt-3">In years past, finding a competent auto technician was a matter of chance. Much of the guesswork
                    has been eliminated, thanks to the national program conducted by the non-profit National Institute
                    for Automotive Service Excellence (ASE). ASE tests and certifies automotive professionals in all
                    major technical areas of repair and service. With nearly 400,000 currently certified professionals,
                    the ASE program is national in scope and has industry-wide acceptance and recognition. ASE requires
                    technicians to re-test every five years to keep up with technology and to remain certified. All ASE
                    credentials have expiration dates. All Certified Auto Repair Centers employ at least one ASE Certified
                    Technician.</p>
                    <img class="w-1/2 xl:w-1/3 float-right clearfix mx-4 my-4 rounded-lg"
                        src="../../assets/img/ase-patch.jpg"
                        alt="The ASE (Automotive Service Excellence) patch on a technician's shoulder"/>
            </section>
            <section>
                <h2 class="text-xl sm:text-xl mt-4">Choosing a Repair Shop Checklist</h2>
                <p class="mt-3">Here are some tips from the non-profit National Institute for Automotive Service Excellence (ASE)
                    on finding a good repair establishment:</p>
                <ul class="views-list mt-3 mb-10">
                    <li>Start shopping for a repair facility before you need one.</li>
                    <li>Ask friends and associates for recommendations; consult local consumer organizations.</li>
                    <li>Arrange for alternate transportation in advance so you will not feel forced to choose
                        a shop based solely on location.</li>
                    <li>Look for a neat, well-organized facility, with vehicles in the parking lot equal in value
                        to your own and modern equipment in the service bays.</li>
                    <li>Look for a courteous staff, with a service writer willing to answer all of your questions.</li>
                    <li>Look for policies regarding labor rates, diagnostic fees, guarantees, acceptable methods of payment, etc.</li>
                    <li>Ask if the repair facility specializes or if it usually handles your type of repair work.</li>
                    <li>Look for signs of professionalism in the customer service area such as civic, community,
                        or customer service awards.</li>
                    <li>Look for evidence of qualified technicians: trade school diplomas, certificates of advanced
                        course work, and certification by ASE.</li>
                    <li>Reward good service with repeat business and customer loyalty.</li>
                </ul>
            </section>
        </div>
        <TheFooter></TheFooter>
    </div>
</template>

<script>
import TheHeader from '@/js/components/TheHeader.vue';
import TheShopsSearch from '@/js/components/TheShopsSearch.vue';
import TheFooter from '@/js/components/TheFooter.vue';

export default {
    name: 'right-shop',
    data() {
        return {
            searchIsFixed: false
        };
    },
    components: {
        TheHeader,
        TheShopsSearch,
        TheFooter
    },
    mounted() {
        this.$root.$on('searchFixedTrue', () => { this.searchIsFixed = true; });
        this.$root.$on('searchFixedFalse', () => { this.searchIsFixed = false; });
    }
};
</script>
